export default "__VITE_ASSET__9826c840__"